// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__KqqBY","calendarButtons":"ClockData_calendarButtons__2YMFB"};